import { Tabs } from "@xola/ui-kit";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Permission } from "types";
import { useAuthorization } from "../../hooks/useAuthorization";
import { CustomConversionTracking } from "./CustomConversionTracking";
import { FacebookConversionTracking } from "./FacebookConversionTracking";
import { GoogleConversionTracking } from "./GoogleConversionTracking";

export const ConversionTracking = () => {
    const { section } = useParams<{ section?: string }>();
    const history = useHistory();
    const { isGranted } = useAuthorization();

    const initialSection = section ?? tabIds[0].id;
    const initialActiveIndex = tabIds.findIndex((tab) => tab.id === section ?? initialSection);
    const [activeTab, setActiveTab] = useState(initialActiveIndex === -1 ? 0 : initialActiveIndex);

    useEffect(() => {
        if (initialActiveIndex >= 0 && activeTab !== initialActiveIndex) {
            setActiveTab(initialActiveIndex);
        }
    }, [initialActiveIndex, activeTab]);

    const changeTab = (tabIndex: number) => {
        history.push(`/marketing/conversionTracking/${tabIds[tabIndex].id}`);
    };

    return (
        <Tabs value={activeTab} onChange={changeTab}>
            <Tabs.Tab isHidden={!isGranted(Permission.FACEBOOK_PIXEL_TRACKING_VIEW)}>Facebook</Tabs.Tab>
            <Tabs.Panel>
                <FacebookConversionTracking />
            </Tabs.Panel>

            <Tabs.Tab isHidden={!isGranted(Permission.CUSTOM_CONVERSION_TRACKING_VIEW)}>Google Tag Manager</Tabs.Tab>
            <Tabs.Panel>
                <GoogleConversionTracking />
            </Tabs.Panel>

            <Tabs.Tab isHidden={!isGranted(Permission.CUSTOM_CONVERSION_TRACKING_VIEW)}>Custom Code</Tabs.Tab>
            <Tabs.Panel>
                <CustomConversionTracking />
            </Tabs.Panel>
        </Tabs>
    );
};

const tabIds = [{ id: "facebook" }, { id: "google" }, { id: "customCode" }];
